import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "p-authentication-callback" }
const _hoisted_2 = { class: "p-account-local__list" }
const _hoisted_3 = ["id", "onClick"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "p-account-local__list__name" }
const _hoisted_6 = { class: "p-form-button-group" }
const _hoisted_7 = { class: "p-form-button-group__buttons-main" }
const _hoisted_8 = { class: "p-form-button-group__horizontal" }
const _hoisted_9 = { class: "p-form-button-group__horizontal" }
const _hoisted_10 = { class: "p-account-local__list" }
const _hoisted_11 = { class: "p-account-local__list__group" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "p-form-button-group" }
const _hoisted_14 = { class: "p-form-button-group__buttons-main" }
const _hoisted_15 = {
  class: "p-form-button-group__horizontal",
  style: {"justify-content":"flex-end"}
}
const _hoisted_16 = { class: "p-account-local__mode" }
const _hoisted_17 = { class: "p-account-local__mode__group" }
const _hoisted_18 = { class: "p-account-local__list__group__radio-option" }
const _hoisted_19 = ["value"]
const _hoisted_20 = { for: "radioA" }
const _hoisted_21 = { class: "p-account-local__mode__group__radio-option" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { for: "radioB" }
const _hoisted_24 = { class: "p-form-button-group" }
const _hoisted_25 = { class: "p-form-button-group__buttons-main" }
const _hoisted_26 = {
  class: "p-form-button-group__horizontal",
  style: {"justify-content":"flex-end"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_IconCheck = _resolveComponent("IconCheck")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_ModalMain = _resolveComponent("ModalMain")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.showModalSupplier)
      ? (_openBlock(), _createBlock(_component_ModalMain, { key: 1 }, {
          head: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("取引先選択 ", -1),
            _createElementVNode("br", null, null, -1),
            _createTextVNode("ログインする取引先を選択して下さい。 ", -1)
          ])),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountList, (account) => {
                return (_openBlock(), _createElementBlock("button", {
                  id: 'btn-' + account.id,
                  key: account.id,
                  class: "p-account-local__list__account",
                  style: {"margin-left":"20px","width":"85%"},
                  onClick: ($event: any) => (_ctx.selectedAccount(account.id))
                }, [
                  _createElementVNode("span", {
                    id: 'check-' + account.id,
                    class: "p-account-local__list__account--current__check"
                  }, [
                    _createVNode(_component_IconCheck, {
                      color: _ctx.checkColor,
                      width: "18px",
                      height: "18px"
                    }, null, 8, ["color"])
                  ], 8, _hoisted_4),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(account.name), 1)
                ], 8, _hoisted_3))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ButtonMain, {
                    type: "button",
                    kind: "aside",
                    onClickButton: _ctx.handleSelectCompany
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("OK", -1)
                    ])),
                    _: 1,
                    __: [5]
                  }, 8, ["onClickButton"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_ButtonMain, {
                    kind: "cancel",
                    onClickButton: _ctx.hide
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("キャンセル", -1)
                    ])),
                    _: 1,
                    __: [6]
                  }, 8, ["onClickButton"])
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showModalGroup)
      ? (_openBlock(), _createBlock(_component_ModalMain, {
          key: 2,
          class: "modal-group"
        }, {
          head: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("グループ選択画面 ", -1)
          ])),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[8] || (_cache[8] = _createElementVNode("p", { class: "p-account-local__list__group__label" }, "グループ選択", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGroupId) = $event)),
                  class: "p-account-local__list__group__select",
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectedGroup && _ctx.selectedGroup(...args)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (group) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: group.group_id,
                      value: group.group_id
                    }, _toDisplayString(group.name), 9, _hoisted_12))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.selectedGroupId]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_ButtonMain, {
                    type: "button",
                    kind: "aside",
                    onClickButton: _ctx.handleSelectGroup
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("選択", -1)
                    ])),
                    _: 1,
                    __: [9]
                  }, 8, ["onClickButton"])
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showSelectMode)
      ? (_openBlock(), _createBlock(_component_ModalMain, {
          key: 3,
          class: "mode-select"
        }, {
          head: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("モード選択画面 ", -1)
          ])),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[11] || (_cache[11] = _createElementVNode("p", { class: "p-account-local__mode__group__label" }, " ログインするアカウントを選択してください。 ", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    id: "radioA",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedModeId) = $event)),
                    type: "radio",
                    name: "selectedMode",
                    value: _ctx.general,
                    style: {"appearance":"auto !important"}
                  }, null, 8, _hoisted_19), [
                    [_vModelRadio, _ctx.selectedModeId]
                  ]),
                  _createElementVNode("label", _hoisted_20, " 個人アカウント：" + _toDisplayString(_ctx.usingEmployeeId), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    id: "radioB",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedModeId) = $event)),
                    type: "radio",
                    name: "selectedMode",
                    value: _ctx.groupbudget,
                    style: {"appearance":"auto !important"}
                  }, null, 8, _hoisted_22), [
                    [_vModelRadio, _ctx.selectedModeId]
                  ]),
                  _createElementVNode("label", _hoisted_23, " グループアカウント：" + _toDisplayString(_ctx.selectedGroupName), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_ButtonMain, {
                    type: "button",
                    kind: "aside",
                    onClickButton: _ctx.handleSelectMode
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("選択", -1)
                    ])),
                    _: 1,
                    __: [12]
                  }, 8, ["onClickButton"])
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}